// const id = localStorage.getItem("companyId") ?? "";
// const parentId = id.replace(/^"(.+)"$/, "$1") ?? "";

// Third Party
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
// helpers
import { useAccessPermission } from "@/helpers/acessPermission";

// UI
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import TableSkeleton from "@/components/skeleton/TableSkeleton";

// Icons
import { PlusCircle, Eye } from "lucide-react";

// Services and Types
import { getCompanyDepartment } from "@/services/soe";
import type { DepartmentList } from "@/types/soe";
import { clearLocalStorage } from "@/helpers/accessLocalStorage";

export const Route = createFileRoute(
  "/_layout-private/account-management/soe/_information/department/"
)({
  component: Departments,
});

function Departments() {
  const navigate = useNavigate();
  const { company_management } = useAccessPermission();
  const id = localStorage.getItem("companyId") ?? "";
  const parentId = id.replace(/^"(.+)"$/, "$1") ?? "";

  // Query
  const { data, isLoading, error } = useQuery({
    queryKey: ["departments", parentId],
    queryFn: () =>
      getCompanyDepartment({
        companyId: parentId,
        limit: 100,
        skip: 0,
      }),
  });

  if (error) {
    const isAxiosError = (
      error: unknown
    ): error is { response?: { data?: { message?: string } } } => {
      return typeof error === "object" && error !== null && "response" in error;
    };

    if (
      isAxiosError(error) &&
      error?.response?.data?.message === "LOGGED_OUT"
    ) {
      console.log("clearing storage due to logged out");
      clearLocalStorage();
      window.location.reload();
    }
  }

  if (isLoading) {
    return <TableSkeleton />;
  }

  // Data
  const departments = data?.data as DepartmentList[];
  const departmentsArray = Array.isArray(departments) ? departments : [];
  console.log(departments, "Department");

  return (
    <div className="space-y-[24px] ">
      <div className="text-[18px]">
        <h2 className="font-semibold text-zinc-950">
          ຂໍ້ມູນການຈັດຕັ້ງຄະນະພະແນກ
        </h2>
        <p className="text-zinc-500">
          ຕາຕະລາງຂໍ້ມູນການຈັດຕັ້ງຄະນະພະແນກຂອງວິສາຫະກິດ
        </p>

        <Separator className="my-6" />
      </div>

      <div className="flex justify-end w-full">
        {company_management.isWrite && (
          <Button
            onClick={() =>
              navigate({
                to: "/account-management/soe/department/mutate",

                search: {
                  id: undefined,
                  data: undefined,
                },
              })
            }
          >
            <PlusCircle className="mr-2" />
            ເພີ່ມຄະນະພະແນກ
          </Button>
        )}
      </div>

      <Table className="rounded-md border">
        <TableHeader className="">
          <TableRow>
            {tableData.headers.map((header) => (
              <TableHead className="whitespace-nowrap" key={header}>
                {header}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {departmentsArray.length > 0 ? (
            departmentsArray.map((item, index) => (
              <TableRow
                key={item?.id}
                className="cursor-pointer"
                onClick={() =>
                  navigate({
                    to: "/account-management/soe/department/$id",
                    params: { id: item.id },
                    search: {
                      data: JSON.stringify(item),
                    },
                  })
                }
              >
                <TableCell className="whitespace-nowrap">{index + 1}</TableCell>
                <TableCell className="whitespace-nowrap">
                  <p className="flex gap-2 items-center">
                    <Eye className="text-blue-500" />
                    {item?.deptName}
                  </p>
                </TableCell>
                <TableCell className="whitespace-nowrap">
                  {item?.empCount}
                </TableCell>
                <TableCell className="whitespace-nowrap">
                  {item?.femaleEmpCount}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell
                colSpan={tableData.headers.length}
                className="py-4 text-center"
              >
                ບໍ່ມີຂໍ້ມູນ
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}

const tableData = {
  headers: [
    "ລຳດັບ",
    "ຊື່ຄະນະພະແນກ",
    "ຈຳນວນພະນັກງານ (ທັງໝົດ)",
    "ຈຳນວນພະນັກງານ (ຍິງ)",
  ],
};
